<template>
  <a-drawer
    :visible="visible"
    title="维修服务项管理"
    width="60%"
    :destroy-on-close="false"
    :mask-closable="false"
    @close="close"
  >
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="状态">
                <a-select placeholder="请选择" v-model="queryParam.status" style="width: 100%" allow-clear>
                  <a-select-option :value="1">启用</a-select-option>
                  <a-select-option :value="0">禁用</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item label="定价类型">
                <a-select placeholder="请选择" v-model="queryParam.pricingType" style="width: 100%" allow-clear>
                  <a-select-option :value="0">固定</a-select-option>
                  <a-select-option :value="1">自定义</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"> <a-icon type="search" />查询 </a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"> <a-icon type="redo" />重置 </a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 操作 -->
      <div class="table-operations">
        <template v-if="isOperate">
          <a-button
            type="primary"
            @click="$refs.createForm.handleAdd(prodSkuId)"
            v-hasPermi="['2627d9a98c563c56cc5cbe56ac95d806c:0:c']"
          >
            <a-icon type="plus" />新增
          </a-button>
          <a-button
            type="danger"
            :disabled="multiple"
            @click="handleDelete"
            v-hasPermi="['2627d9a98c563c56cc5cbe56ac95d806r:0:r']"
          >
            <a-icon type="delete" />删除
          </a-button>
          <a-button type="primary" @click="handleExport" v-hasPermi="['2627d9a98c563c56cc5cbe56ac95d806e:0:e']">
            <a-icon type="download" />导出
          </a-button>
        </template>

        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>

      <!-- 新增/编辑 -->
      <create-form
        ref="createForm"
        :userList="userList"
        :statusOptions="dict.type['sys_enable_disable']"
        @ok="getList"
      />

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="serviceItemId"
        :columns="columns"
        :data-source="list"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="status" slot-scope="text, record">
          <a-tag :color="record.status === 1 ? 'green' : 'red'">
            {{ record.status === 1 ? '启用' : '禁用' }}
          </a-tag>
        </span>

        <span slot="pricingType" slot-scope="text, record">
          <span v-if="record.pricingType == 0">固定价格{{ record.price }}</span>
          <span v-else>最小定价{{ record.priceMin }}-最高定价{{ record.priceMax }}</span>
        </span>

        <span slot="operation" slot-scope="text, record">
          <a @click="handleDelete(record)" v-hasPermi="['2627d9a98c563c56cc5cbe56ac95d806r:0:r']"> 删除 </a>
        </span>
      </a-table>

      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </a-drawer>
</template>

<script>
import { fetchList, delObj, statusObj } from '@/api/maintenance/servicePricing/index'
import CreateForm from './ServicePricingCreateForm.vue'
import { tableMixin } from '@/store/table-mixin'
import { listTenant } from '@/api/system/tenant'

export default {
  name: 'ServicePricingDrawer',
  components: { CreateForm },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  props: {
    isOperate: { type: Boolean, default: true },
  },
  data() {
    return {
      advanced: false, // 控制高级搜索的显示
      multiple: true, // 控制删除按钮的禁用状态
      prodSkuId: undefined,
      visible: false,
      list: [],
      userList: [],
      selectedRowKeys: [],
      selectedRows: [],
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        status: undefined,
        pricingType: undefined,

        prodSkuId: undefined,
      },
      columns: [
        // { title: 'id', dataIndex: 'prodSkuId', align: 'center' },
        { title: '服务名称', dataIndex: 'serviceItemName', align: 'center' },
        {
          title: '定价',
          dataIndex: 'pricingType',
          align: 'center',
          scopedSlots: { customRender: 'pricingType' },
        },
        {
          title: '状态',
          dataIndex: 'status',
          align: 'center',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '排序号',
          dataIndex: 'sort',
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: '15%',
          align: 'center',
          scopedSlots: { customRender: 'operation' },
        },
      ],
    }
  },
  methods: {
     handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'upkeep/prod/sku/svc/export',
            {
              ...that.queryParam,
            },
            `维修产品服务项管理信息${new Date().getTime()}.xlsx`,
            'POST'
          )
        },
        onCancel() {},
      })
    },

    open(row) {
      this.visible = true
      this.queryParam.prodSkuId = row.id
      this.prodSkuId = row.id
      this.getList()
      if (!this.tenantFirmId) this.getQi()
    },
    close() {
      this.visible = false
      this.selectedRowKeys = []
      this.selectedRows = []
      this.ids = []
    },
    getQi() {
      listTenant({ pageNum: 1, pageSize: 999, type: 1, status: 0 }).then((res) => (this.userList = res.data.records))
    },
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((res) => {
        this.list = res.data.records
        this.total = res.data.total
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = Object.assign({}, this.queryParam, {
        pageNum: 1,
        pageSize: 10,
        status: undefined,
        pricingType: undefined,
      })
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((v) => v)
    },
    handleStatusType(row, newStatus) {
      statusObj({
        prodSkuId: row.prodSkuId,
        serviceItemId: row.serviceItemId,
      })
        .then(() => {
          this.$message.success('操作成功！')
          this.getList()
        })
        .catch(() => {
          row.status = row.status === 0 ? 1 : 0
        })
    },
    handleDelete(row) {
      let ids = []
      if (row.serviceItemId) {
        ids = [{ prodSkuId: row.prodSkuId, serviceItemId: row.serviceItemId }]
      } else {
        ids = this.ids.map((v) => ({
          prodSkuId: v.prodSkuId,
          serviceItemId: v.serviceItemId,
        }))
      }
      this.$confirm({
        title: '是否确认删除此数据?',
        onOk: () =>
          delObj(ids).then(() => {
            this.onSelectChange([], [])
            this.getList()
            this.$message.success('删除成功')
          }),
      })
    },
  },
}
</script>
